import { MiqMoment } from '../misc/sanitizers';

/**
 * L2-R7: moved from `src/app/shared/models/reports/helpers/report-name-extractors.ts` (and its
 * one-line `index.ts` barrel). Pure string/date helpers for report tree names.
 *
 * The host original imported `MiqMoment` from `@shared/utils/helpers/sanitizers`; this file uses
 * the @miq/utils copy. `dateFormatter` only touches `MiqMoment.format`, which is byte-identical in
 * both copies (`isMasked(d) ? d : moment(d).utc().format(fmt)`), so behaviour is unchanged. The
 * `formatNumber`/`MiqMoment.getFormattedDate` divergences between the two sanitizers copies do not
 * apply here.
 *
 * The `name` parameter was typed `DataObject` (@miq/shared-models) upstream; @miq/utils is built
 * BEFORE @miq/shared-models, so it is typed structurally here instead. Every call site passes a
 * report/folder row, which always has a string `name`.
 */
export const reportNameExtractor = ({ name }: { name: string }) => {
  const path = name.split('/');
  return decodeURIComponent(path[path.length - 1]);
};
export const serializeFolderPath = path => path.split('/').map(encodeURIComponent).join('/');
export const deserializeFolderPath = path => path.split('/').map(decodeURIComponent).join('/');
export const subTitleExtractor = ({ name }) => deserializeFolderPath(name.substring(0, name.lastIndexOf('/')));
export const dateFormatter = (field, format, row) => (row[field] ? MiqMoment.format(row[field], format) : '');
